/** Well-known constants for schema sections (specs/schema-sections.md § Well-known names). */

export const SECTION_SYSTEM_NAME_PATTERN = /^[a-z][a-z0-9_]{1,47}$/;

/** Order of the implicit Details group, which holds every unsectioned property. */
export const DEFAULT_SECTION_ORDER = 500;

export const MAX_SECTIONS_PER_SCHEMA = 30;

/** Sections seeded on `center_baseschema` and inherited by every schema type. */
export const BUILT_IN_SECTIONS = {
  identity: 'identity',
  purpose: 'purpose',
  metrics: 'metrics',
  record: 'record',
  members: 'members',
} as const;
